import { useResponsive } from '@depop/web-ui-kit/useResponsive';

import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';
import { type SimilarProduct } from '@/modules/similar/aliases';
import {
  YMAL_DESKTOP_PRODUCTS_PER_SEGMENT,
  YMAL_DESKTOP_SEGMENT_ROWS,
  YMAL_DESKTOP_ITEMS_PER_ROW,
  YMAL_MOBILE_PRODUCTS_PER_SEGMENT,
  YMAL_MOBILE_SEGMENT_ROWS,
} from '@/modules/similar/constants';
import { createYMALSegments } from '@/modules/similar/helpers/createYMALSegments';
import { getSegmentItemsPerRowCount } from '@/modules/similar/helpers/getSegmentItemsPerRowCount';

export function useSegments(similarProducts: SimilarProduct[] = []) {
  const { isMaxMedium: isMobile } = useResponsive();
  const { data: product } = useProductBySlugBasicPDP();
  const { data: productExtended } = useProductBySlugExtendedPDP();

  const segmentSize = isMobile
    ? YMAL_MOBILE_PRODUCTS_PER_SEGMENT
    : YMAL_DESKTOP_PRODUCTS_PER_SEGMENT;

  const segments = createYMALSegments({
    product,
    productExtended,
    segmentSize,
    similarProducts,
  });

  const segmentRows = isMobile
    ? YMAL_MOBILE_SEGMENT_ROWS
    : YMAL_DESKTOP_SEGMENT_ROWS;

  const segmentItemsPerRowCount = getSegmentItemsPerRowCount({
    segmentSize,
    segmentRows,
    productsCount: similarProducts.length,
  });

  return {
    itemsPerRow: isMobile
      ? segmentItemsPerRowCount
      : YMAL_DESKTOP_ITEMS_PER_ROW,
    segments,
  };
}
